<template>
<div class="action-buttons">
	<b-form-group class="pull-right">
		<b-button-group>
			<b-button type="button"
			          v-if="!disablePrevious"
			          variant="outline-secondary"
			          v-b-tooltip.hover
			          title="Vorige"
			          @click="$emit('previous-item')">
				<i class="fa fa-fw fa-angle-double-left"></i>
			</b-button>
			<b-button type="button"
			          v-if="!disableNext"
			          variant="outline-secondary"
			          v-b-tooltip.hover
			          title="Volgende"
			          @click="$emit('next-item')">
				<i class="fa fa-fw fa-angle-double-right"></i>
			</b-button>
		</b-button-group>

		<b-button-group>

			<b-button v-if="!disableDelete"
			          type="button"
			          variant="danger"
			          v-b-tooltip.hover
			          title="Verwijderen"
			          @click="showDeleteModal">
				<fa-icon icon="trash" />
			</b-button>

		</b-button-group>


		<b-button-group>

			<b-button right
			          type="submit"
			          variant="primary"
			          v-b-tooltip.hover
			          title="Opslaan">
				<i class="fa fa-fw fa-save"></i>
			</b-button>

			<b-button v-if="!disableSaveAndNew"
			          type="button"
			          variant="primary"
			          v-b-tooltip.hover
			          title="Opslaan en nieuw"
			          @click="$emit('save-and-new')">
				<i class="fa fa-fw fa-plus"></i>
			</b-button>

			<b-button type="button"
			          variant="primary"
			          v-b-tooltip.hover
			          title="Opslaan en terug"
			          @click="$emit('save-and-back')"><i class="fa fa-fw fa-reply"></i></b-button>

		</b-button-group>

		<b-button type="button"
		          variant="outline-secondary"
		          v-b-tooltip.hover
		          title="Terug"
		          @click="$emit('back')"><i class="fa fa-fw fa-reply"></i></b-button>
	</b-form-group>
	<delete-dialog-modal ref="deleteModal"
	                     @confirm="$emit('delete')"
	                     :delete-name="deleteName"
	                     :is-deleting="isDeleting"></delete-dialog-modal>
</div>
</template>

<script>
import DeleteDialogModal from './DeleteDialogModal';

export default {
	components: {
		DeleteDialogModal
	},
	data() {
		return {}
	},
	props: {
		disableSaveAndNew: {
			type: Boolean,
			default: false
		},
		disableNext: {
			type: Boolean,
			default: false
		},
		disablePrevious: {
			type: Boolean,
			default: false
		},
		disableDelete: {
			type: Boolean,
			default: false
		},
		deleteName: {
			type: String,
			default: ''
		},
		isDeleting: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		/**
		 * Show delete modal
		 */
		showDeleteModal() {
			this.$refs.deleteModal.show();
		},

		hideDeleteModal() {
			this.$refs.deleteModal.hide();
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ActionButtons.vue?53e24aeb